<!--
 * @Author: Ximen
 * @Date: 2021-03-17 14:12:51
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-15 14:01:54
-->
<template>
  <div class="bg">
    <div style="height:100%">
      <a-card style="margin-top:258px" class="box">
        <p class="title">订购成功</p>
        <img class="blank" src="@/assets/undraw_done_a34v.png" alt="">
        <p class="consulting">到期时间：{{time}}</p>
        <a-button type="primary" class="accept-btn" @click="backToShop()">返回商城首页</a-button>
      </a-card>
    </div>
  </div>
</template>

<script lang='ts'>
import commonApi from '@/api/common';
import { defineComponent } from 'vue';
import { message as $message } from 'ant-design-vue';
import environment from '@/untils/environment';
import moment from 'moment';

export default defineComponent({
  name: 'PayResult',
  components: {
  },
  data() {
    const lists: Array<object> = [];
    return {
      time: '',
      list: lists,
      type: -1,
    };
  },
  setup() {
    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };
    return {
      error,
      success,
    };
  },
  mounted() {
    this.getShopInfo();
    this.getDataConfForSaas();
  },
  methods: {
    backToShop() {
      const accountId = localStorage.getItem('accountId');
      const memberId = localStorage.getItem('memberId');
      const token = localStorage.getItem('token');
      const siteId = localStorage.getItem('siteId');
      const loc = window.location;
      const uri = loc.host;
      const url = `http://${uri.indexOf('pre') === -1 ? 'hdsupport.saas.seatent.com' : 'hdsupport.saas.saaspre.seatent.com'}/#/callback?randomCode=42rfmhh9x73juwvw&approach=22&token=${token}&accountId=${accountId}&appkey=${environment.appkey}&siteId=${siteId}&memberId=${memberId}&link=/home/go`;
      console.log(url);
      window.location.href = url;
    },
    getShopInfo() {
      interface Data{
        data: Shopinfo;
        success: boolean;
        message: string;
      }
      interface Shopinfo{
        versionEndTime: number;
        versionType: number;
      }
      commonApi.getShopInfo({}).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          this.time = moment(data.versionEndTime).format('YYYY-MM-DD');
          this.type = data.versionType;
        } else {
          console.log(message);
          this.error(message);
        }
      });
    },
    getDataConfForSaas() {
      interface Data{
        data: [];
        success: boolean;
        message: string;
      }
      commonApi.getDataConfForSaas({ })
        .then(async ({ data, success, message }: Data) => {
          if (success) {
            console.log(data);
            interface SData{
              createAccount: string;
              id: number;
              key: string;
              name: string;
              remark: string;
              sort: number;
              type: string;
              typeName: string;
              updateAccount: string;
              value: string;
            }
            data.forEach((element: SData) => {
              this.list.push(element);
            });
          } else {
            this.error(message);
            console.log(message);
          }
        });
    },
  },
});
</script>
<style lang="stylus" scoped>
  .bg
    background url('../../assets/background.jpg') no-repeat
    background-size 100% 100%
    width 100%
    min-height 100vh
    overflow: hidden;
    .box
      margin 0 auto
      border-radius 20px
      width 420px
      .title
        font-size 24px
        color #073D7D
        margin-bottom 40px
      .blank
        width 220px
        height auto
        margin-bottom 40px
      .accept-btn
        width 100%
        height 50px
        margin-top 10px
        border-radius 5px
        background #3281DD
        margin-bottom 30px
      .consulting
        font-size 14px
        color #073D7D
</style>
